import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTracking } from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';
import GuestRegistrationModal from '@/components/GuestRegistrationModal';
import useUser from '@/hooks/useUser';

export const AddPortfolioBanner = () => {
  const { trackEvent } = useTracking();
  const [openRegistrationModal, setOpenRegistrationModal] = useState(false);
  const { data: user } = useUser();
  const dispatch = useDispatch();

  const handleCreatePortfolioClick = () => {
    trackEvent({
      subject: 'banner',
      modifier: 'createNewPortfolio',
      action: 'click',
    });

    if (user.loggedIn) {
      return dispatch({ type: ROUTE_PORTFOLIO_NEW });
    }
    setOpenRegistrationModal(true);
  };

  return (
    <>
      <div
        data-cy-id="demo-portfolio-banner"
        className="radius-x1 rounded-x1 bg-surface-1 p-x1_5"
      >
        <div className="grid grid-cols-[auto_max-content] justify-between gap-x1">
          <div className="items-start px-x1 md:items-center md:px-x2">
            <div className="grid size-full items-center text-pretty text-xs">
              Analyze and improve your own portfolio for free.
            </div>
          </div>
          <Button styleType="louderLarge" onClick={handleCreatePortfolioClick}>
            Add my portfolio
          </Button>
        </div>
      </div>
      {openRegistrationModal && (
        <GuestRegistrationModal
          canClose
          onClose={() => {
            trackEvent({
              action: 'close',
              modifier: 'log_in_sign_up',
            });
            setOpenRegistrationModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioBanner',
              modifier: 'registration',
              action: 'success',
            });
            setOpenRegistrationModal(false);
            dispatch({ type: ROUTE_PORTFOLIO_NEW });
          }}
          onLoginSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioBanner',
              modifier: 'login',
              action: 'success',
            });
            setOpenRegistrationModal(false);
            dispatch({ type: ROUTE_PORTFOLIO_NEW });
          }}
        />
      )}
    </>
  );
};
